import { MAX_SCALE, MIN_SCALE } from './outlineGeometry';

/** Scales location plans are commonly drawn at, offered when the printed scale may have been misread. */
export const COMMON_SCALES = [200, 500, 1000, 1250, 2500, 5000, 10000] as const;

/**
 * The scales (denominators, smallest first) a plan read at 1:`readDen` can be set to: the common ones within the outline's
 * resize limits, and the read scale itself whether or not it is common.
 */
export function scaleStops(readDen: number): number[] {
  const within = (d: number) => d / readDen >= MIN_SCALE - 1e-9 && d / readDen <= MAX_SCALE + 1e-9;
  return [...new Set([...COMMON_SCALES.filter(within), readDen])].sort((a, b) => a - b);
}

/** The outline's resize factor for drawing a plan read at 1:`readDen` at 1:`den` instead (a larger denominator covers more ground). */
export function scaleFactor(den: number, readDen: number): number {
  return den / readDen;
}

/** Index of the stop nearest an outline resized by `factor` from the plan read at 1:`readDen` (nearest by ratio, not difference). */
export function nearestStop(stops: readonly number[], readDen: number, factor: number): number {
  const den = readDen * factor;
  let best = 0;
  for (let i = 1; i < stops.length; i++) {
    if (Math.abs(Math.log(stops[i] / den)) < Math.abs(Math.log(stops[best] / den))) best = i;
  }
  return best;
}
